import { useState, useCallback, useMemo, useEffect } from 'react';
import { hasAccessRole } from 'js/lib/ACLUtils';
import { TabValue, TabConfig } from '../types';

const TABS_WITH_SHARE: TabConfig[] = [
  { value: 'overview', label: 'Overview' },
  { value: 'rules', label: 'Rules' },
  { value: 'stats', label: 'Stats' },
  { value: 'activity', label: 'Activity' },
  { value: 'errorData', label: 'Error Data' },
  { value: 'share', label: 'Share' },
];

const TABS_WITHOUT_SHARE: TabConfig[] = [
  { value: 'overview', label: 'Overview' },
  { value: 'rules', label: 'Rules' },
  { value: 'stats', label: 'Stats' },
  { value: 'activity', label: 'Activity' },
  { value: 'errorData', label: 'Error Data' },
];

/**
 * Hook for managing shared dataset detail tabs state.
 * Determines which tabs to show based on dataset access roles.
 *
 * @param dataset - The dataset object
 * @param initialTab - Initial active tab (default: 'overview')
 * @param onTabChange - Optional callback when tab changes
 * @returns Tab state and handlers
 */
export function useSharedDatasetTabs(
  dataset: any | undefined,
  initialTab: TabValue = 'overview',
  onTabChange?: (tabValue: TabValue) => void,
) {
  const [activeTab, setActiveTab] = useState<TabValue>(initialTab);
  const datasetId = dataset?.id;

  useEffect(() => {
    setActiveTab(initialTab);
  }, [datasetId, initialTab]);

  const hasSharerAccess = useMemo(() => hasAccessRole(dataset, 'sharer'), [dataset]);

  const handleTabChange = useCallback(
    (_: React.SyntheticEvent, newValue: TabValue) => {
      setActiveTab(newValue);
      onTabChange?.(newValue);
    },
    [onTabChange],
  );

  // const tabs = useMemo(() => {
  // This is original logic, but within marketplace we should never show the share tab
  //   const accessRoles = dataset?.access_roles;
  //   if (
  //     hasSharerAccess ||
  //     !accessRoles ||
  //     (Array.isArray(accessRoles) && accessRoles.length === 0)
  //   ) {
  //     return TABS_WITHOUT_SHARE;
  //   }
  //   return TABS_WITH_SHARE;
  // }, [dataset, hasSharerAccess]);

  const tabs = TABS_WITHOUT_SHARE;

  return {
    activeTab,
    setActiveTab,
    hasSharerAccess,
    handleTabChange,
    tabs,
  };
}
